import { mapGetters, mapMutations } from 'vuex';

import EditPerson from './../Common/editPerson.vue'
import EditCompany from './../Common/editCompany.vue'

export default {
    name: 'EditOwner',

    props: {

    },

    components: {
        EditPerson,
        EditCompany
    },

    data: () => {
        return {
            loading: true,
        }
    },

    created() {

    },

    computed: {
        ...mapGetters(
            {
                // general
                appSettings: 'general/appSettings',
                userSettings: 'general/userSettings',
                orderTypeSettings: 'general/orderTypeSettings',
                orderTypeSettingsLoaded: 'general/orderTypeSettingsLoaded',
                settingsLoaded: 'general/settingsLoaded',
                typeSettings: 'general/typeSettings',

                // order
                orderEditable: 'order/orderEditable',
                company: 'order/company',
                owner: 'order/owner',
                person: 'order/person',

            }),
    },

    methods: {
        ...mapMutations(
            {
                setCompany: 'order/setCompany',
                setOwnerType: 'order/setOwnerType',
                setPerson: 'order/setPerson',
            }),
        //
        validate: function () {
            if (this.owner.OwnerType == 0)
                return this.$refs.editPerson.validate();

            if (this.owner.OwnerType == 1)
                return this.$refs.editCompany.validate();
        },
        //
        ownerType_Changed: function (value) {

            console.log('ownerType_Changed to ' + value)

            if (value == 0 && this.person == null) {
                const emptyPerson = {
                    Id: 0,
                    IsActive: false,
                    FirstName: null,
                    LastName: null,
                    UniqueId: null,
                    IdCard: null,
                    DrivingLicense: null,
                    DrivingLicenseDate: null,
                    HasHandicap: null,
                    IsRetired: null,
                    Phone: null,
                    Email: null,
                    AddressId: null,
                    OwnerId: 0
                }
                this.setPerson(emptyPerson);
            }
            else if (value == 1 && this.company == null) {
                const emptyCompany = {
                    Id: 0,
                    IsActive: false,
                    UniqueId: null,
                    Name: null,
                    FieldOfActivity: null,
                    Phone: null,
                    Email: null,
                    AddressId: null,
                    OwnerId: 0,
                }
                this.setCompany(emptyCompany);
            }

            // change owner type
            this.setOwnerType(value);
        }
    },
}
